import store from '../store'
const API_REPORTS = process.env.VUE_APP_API_REPORTS || window.location.origin
const url = require('url')

export default {

  /**
   * MS Best Sellers
   */
  best_sellers: params => fetch(`${API_REPORTS}/best-sellers${url.format({ query: params })}`, {
    headers: {
      'Authorization': `Bearer ${store.state.login.token}`
    }
  }),

  /**
   * MS Clients Statistics
   */
  clients_statistics: params => fetch(`${API_REPORTS}/clients-statistics${url.format({ query: params })}`, {
    headers: {
      'Authorization': `Bearer ${store.state.login.token}`
    }
  }),

  /**
   * MS Finance
   */
  finance: params => fetch(`${API_REPORTS}/finance${url.format({ query: params })}`, {
    headers: {
      'Authorization': `Bearer ${store.state.login.token}`
    }
  }),

  /**
   * MS Purchases
   */
  purchases: params => fetch(`${API_REPORTS}/purchases${url.format({ query: params })}`, {
    headers: {
      'Authorization': `Bearer ${store.state.login.token}`
    }
  }),

  /**
   * MS Purchases by Area
   */
  purchases_area: params => fetch(`${API_REPORTS}/purchases-by-area${url.format({ query: params })}`, {
    headers: {
      'Authorization': `Bearer ${store.state.login.token}`
    }
  }),

  /**
   * MS Purchases Charts by Area
   */
  purchases_charts_area: params => fetch(`${API_REPORTS}/purchases-charts-area${url.format({ query: params })}`, {
    headers: {
      'Authorization': `Bearer ${store.state.login.token}`
    }
  }),

  /**
   * MS Sales After Taxes
   */
  sales_after_tax: params => fetch(`${API_REPORTS}/sales-after-tax${url.format({ query: params })}`, {
    headers: {
      'Authorization': `Bearer ${store.state.login.token}`
    }
  }),

  /**
   * MS Sales After Taxes by Paymethod
   */
  sales_after_tax_paymethod: params => fetch(`${API_REPORTS}/sales-after-tax-paymethod${url.format({ query: params })}`, {
    headers: {
      'Authorization': `Bearer ${store.state.login.token}`
    }
  }),

  /**
   * MS Sales Before Taxes
   */
  sales_before_tax: params => fetch(`${API_REPORTS}/sales-before-tax${url.format({ query: params })}`, {
    headers: {
      'Authorization': `Bearer ${store.state.login.token}`
    }
  }),

  /**
   * MS Chart Sales by Area
   */
  sales_charts_area: params => fetch(`${API_REPORTS}/sales-charts-area${url.format({ query: params })}`, {
    headers: {
      'Authorization': `Bearer ${store.state.login.token}`
    }
  }),

  /**
   * MS Chart Sales by Paymethod
   */
  sales_charts_paymethod: params => fetch(`${API_REPORTS}/sales-charts-paymethod${url.format({ query: params })}`, {
    headers: {
      'Authorization': `Bearer ${store.state.login.token}`
    }
  })
}
